<template>
  <div class="box-tree-content">
    <el-tree class="tree-comp" :props="defaultProps"
             :filter-node-method="filterNodeTree"
             :load="loadNode"
             accordion
             highlight-current
             node-key="id"
             ref="catagoryTree"
             lazy
             :render-content="renderContent"
             @node-click="handleNodeClick">
    </el-tree>
    <!-- <div class="explain"></div> -->
  </div>
</template>

<script>
  import categoryApi from "@/api/rescategory"
  import configJosn from "../../../static/config.json";

  export default {
    name: 'leftTree',
    data() {
      return {
        tableLoading: false,
        firstNode:null,
        defaultProps: {
          id: "id",
          //label: "categoryName",
          appExplain:'',
          label: "extStr",
          //true 叶节点，不显示孩子
          isLeaf: (data, node) => {
            if (data.subNodeFlag == 0) {
              return true
            }
          }
        },
      }
    },
    props: {
      paramData: {
        type: [Object],
      }
    },
    created() {
      this.initData()
    },
    mounted(){
      console.log(this.paramData.title);
      console.log("read config from out file. ",configJosn.procedureGuid);
    },
    methods:{
      initData(){
        console.log('init param: ',this.paramData)
      },
      filterNodeTree (value, data, node) {
        if (!value) {
          node.expanded = false
          return true;
        }else{
          return false;
        }
      },
      loadNode(node, resolve) {
        let resourceCode = this.paramData.resourceCode
        console.log('resourceCode: ',resourceCode)
        var queryData = {
          'parentId': -1,
          'resourceCode': resourceCode
        };
        if (undefined != node.data) {
          queryData.parentId = node.data.id;
        }
        this.firstNode = node;
        var treeData = []

        categoryApi.getListByParentId(queryData).then(res => {
          if (res.data.code == 0){
            treeData = res.data.data;
            this.tableLoading = false;
            if (node.level == 0) {
              this.$nextTick(() => {
                if (this.firstNode.childNodes.length){
                  let nodedata = this.firstNode.childNodes[0];
                  nodedata.expanded = true;
                  nodedata.loadData();
                }
              });
            }
            resolve(treeData)
          }
        })
      },
      handleNodeClick(node) {
        this.$emit('categoryClick',node)
      },
      renderContent(h, {node,data,store}) {
        if (node.level == 1) {
          return ( < span> < i class = 'el-icon-goods'
                                style = "color: #409EFF; height=40px; line-height:40px;font-size:14px" > </i>
                                <span style="margin-left:10px;height=40px; line-height:40px;font-size:14px" title={node.label}>{node.label}</span > </span>);
        } else {
          return ( < span> < i class = 'el-icon-news'
                                style = "color: #FFB427; height=40px;" > </i><span style="margin-left:10px" title={node.label}>{node.label}</span > </span>);
        }
      },
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .box-content-content{
    width: 200px;
    border: 1px solid #e7e7e7;
    height: 100%;
  }

  .tree-comp{
    //overflow: auto;
    flex: 1;
    // height: 1040px;
    margin: 10px;
    .el-tree-node{
      min-width: 95%;
      display:inline-block;
    }
    .el-tree-node__children{
      overflow: visible !important
    }
    /deep/ .el-tree-node__label{
      font-size: 16px;
      font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
      line-height: 30px;
      margin-top: 10px;
      float: left;
      letter-spacing: 1px;
      width: auto;
      color:#999999;
    }
    /deep/ .is-leaf.el-tree-node_expand-icon  {
      display:none;
    }
  }
  .explain{
    height: 300px;
    bottom: 10px;
    background-color: darkgray;
  }
  
</style>



// WEBPACK FOOTER //
// src/view/column/lefttree.vue